import { AccountSubtype } from "@common/constants/domains/accounting/accounts";

export {
    buildHierarchicalChartOfAccounts,
    getDefaultExpandedState,
    type ChartOfAccountsRow,
} from "@common/helpers/domains/accounting/buildHierarchicalChartOfAccounts";

export const SUBTYPE_TO_SWAP_DIRECTIONS: AccountSubtype[] = [
    AccountSubtype.paymentProcessor,
    AccountSubtype.bankAccount,
    AccountSubtype.creditCard,
];
